import React, { useRef, useState } from "react";
import { BsExclamation, BsCheck2 } from "react-icons/bs";
import TextModal from "./TextModal";
import languageStorage from "../lang/findLanguage";
import emailjs from "emailjs-com";
import pdf from "../assets/bandwitt-kvkk-formu.pdf";

export default function ApplicationForm({ language }) {
  const [kvkkPolicy] = useState({
    id: 3,
    title: "KVKK Politikası",
    text: [
      "<p>BANDWITT Teknoloji Hizmetleri Ltd. Şti. (‘BANDWITT’) olarak kişisel verilerinizin güvenliğine önem vermekte ve sizlere sunduğumuz hizmetlerde bu verilerin kullanılması esnasında özel hayatın, temel hak ve özgürlüklerin korunmasını temel ilke olarak görmekteyiz.</p>",
      "<ul>1) Veri Sorumlusu</ul>",
      "<p>6698 sayılı Kişisel Verilerin Korunması Kanunu (‘KVK Kanunu’) hükümleri kapsamında, kişisel verileriniz, veri sorumlusu olarak Harbiye Mahallesi Abdi İpekçi Caddesi No:19-1/1 34367 Şişli/İstanbul adresinde bulunan BANDWITT Teknoloji Hizmetleri Ltd. Şti. (‘BANDWITT’) tarafından aşağıda açıklanan kapsamda işlenebilecektir.</p>",
      "<ul>2)	Kişisel Verilerinizin İşlenme Amaçları</ul>",
      "<p>Toplanan kişisel verileriniz, ticari faaliyetlerimizi yürütmek çerçevesinde ‘KVK Kanunu’nun 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları dahilinde aşağıda amaçlarla işlenecektir:</p>",
      "<li>•	Firmamızın sunduğu ürün ve hizmetlerden faydalanabilmeniz için gerekli çalışmaların yapılması</li>",
      "<li>•	Ürün ve hizmetlerimizin, sizlerin kullanımına ve ihtiyaçlarına göre özelleştirilmesi</li>",
      "<li>•	BANDWITT’ve ’BANDWITT’ ile iş ilişkisi içerisinde olan kişilerin hukuki ve ticari güvenliğinin sağlanması</li>",
      "<ul>3)	Kişisel Verilerinizin Aktarımı</ul>",
      "<p>Toplanan kişisel verileriniz yukarıda belirtilen amaçlar doğrultusunda; iş ortaklarımıza, tedarikçilerimize, faaliyetlerimizi yürütmek üzere hizmet alınan üçüncü taraflara, kanunen yetkili kamu kurumları ve özel kişilere; ticari faaliyetlerimizi yürütmek amacıyla, ‘KVK Kanunu’nun 8. ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları çerçevesinde, web sayfamız üzerinde yer alan ‘KVVK Politikası’nda belirtilmiş olan amaçlarla sınırlı olarak aktarılabilecektir. </p>",
      "<ul>4)	Kişisel Veri Sahibinin KVK Kanunu’nun 11. Maddesi Kapsamındaki Hakları</ul>",
      "<p>Kişisel veri sahipleri olarak, haklarınıza ilişkin taleplerinizi yazılı olarak veya web sayfamız üzerinden tarafımıza iletmeniz durumunda, firmamız talebin niteliğine göre talebi en kısa sürede ve en geç otuz gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyet gerektirmesi durumunda, ‘Kurul’ tarafından belirlenen tarifedeki ücret tahsil edecektir.</p>",
      "<p>Firmamıza başvurmak suretiyle, kişisel veri sahipleri, kişisel verilerinin;</p>",
      "<li>a)	İşlenip işlenmediğini öğrenme</li>",
      "<li>b)	İşlenmişse bilgi talep etme</li>",
      "<li>c)	İşlenme amacını ve amacına uygun kullanıp kullanılmadığını öğrenme</li>",
      "<li>d)	Yurt içinde/yurt dışında aktarıldığı 3. kişileri bilme</li>",
      "<li>e)	Eksik/yanlış işlenmişse düzeltilmesini isteme</li>",
      "<li>f) KVK Kanunu’nun 7. Maddesinde öngörülen şartlar çerçevesinde silinmesini/yok edilmesini isteme</li>",
      "<li>g)	(e) ve (f) maddeleri uyarınca yapılan işlemlerin, kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>",
      "<li>h)	Münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>",
      "<li>i)	Kanuna aykırı işlenmesi sebebiyle zarara uğramanız halinde zararınızın giderilmesini talep etme haklarına sahiptir.</li>",
      "<ul>5)	Veri Sorumlusu’na Başvuru ve Başvuru Yöntemi</ul>",
      "<p>‘KVK Kanunu’nun 13. maddesinin 1. fıkrası gereğince yukarıda belirtilen haklarınızı kullanmakla ilgili talebinizi ‘yazılı veya Kişisel Verilerin Korunması Kurulu’nun (‘Kurul’) belirlediği diğer yöntemlerle firmamıza iletmeniz gerekmektedir. </p>",
      "<p>Bu çerçevede Şirketimize KVK Kanunu’nun 13. maddesine dayalı olarak ‘KVK Kanunu’nun yukarıda belirtilen 11. maddesindeki haklarını kullanmak kapsamında yapacağınız başvurularda yazılı olarak başvurunuzu ileteceğiniz kanallar ve usuller aşağıda açıklanmaktadır.</p>",
      `<p>‘www.bandwitt.com’ üzerinde bulunan KVK başvuru formu’nu (“<a href='${pdf}' target='_blank'>KVKK Başvuru Formu</a>”) eksiksiz ve açık bir şekilde doldurup imzaladıktan sonra aşağıda belirtilen adresimize elden veya iadeli taahhütlü posta yolu ile iletmenizin ardından en geç 30 (otuz) gün içinde başvurunuzu cevaplayacağız.  </p>`,
      "<p>Bu çerçevede ‘yazılı’ olarak firmamıza yapılacak başvurular, işbu formun çıktısı alınarak;</p>",
      "<li>•	Başvuru sahibinin şahsen başvurusu ile,</li>",
      "<li>•	Noter vasıtasıyla,</li>",
      "<p><br /><b>Firma Bilgilerimiz:</b> <br /> Ticaret Ünvanı: BANDWITT Teknoloji Hizmetleri Ltd. Şti <br /> Adres: Harbiye Mahallesi, Abdi İpekçi Caddesi No:19-1/1 34367 Şişli/İstanbul  <br />  Mersis No: 0140 0551 6000 0001 <br /> Web Sayfası: <a href='https://bandwitt.com/' target='_blank'>www.bandwitt.com</a>  <br /></p>",
    ],
  });
  const [consentText] = useState({
    id: 3,
    title: "Açık Rıza Metni",
    text: [
      "<p>BANDWITT Teknoloji Hizmetleri Ltd. Şti. (‘BANDWITT’)  ile paylaşmış olduğum iletişim bilgilerimin (Ad, soyad, e-mail, telefon, firma bilgileri) her türlü iş geliştirme faaliyeti kapsamında kullanılmasına, tarafımla, e-posta, SMS ve telefon kanallarıyla iletişime geçilmesine ve belirtilen yollarla tarafıma ticari elektronik ileti gönderilmesine 6563 Sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun kapsamında onay verdiğimi; bu kapsamda ‘BANDWITT’ ile paylaşmış olduğum kişisel verilerimin gizliliklerinin korunması için gerekli tedbirler alınarak; 6698 Sayılı Kişisel Verilerin Korunması Kanunu’na ve kanuni ilkelere uygun şekilde, veri sorumlusu ‘BANDWITT’ ile bu şirketin ortakları, iş ortakları, halefleri ve/veya bunların belirleyeceği üçüncü kişiler tarafından, yasal nedenlerle otomatik olan/olmayan yöntemler ile alınmasına, yasal süreler aşılmamak üzere yurt içinde ve/veya yurt dışında yazılı/dijital arşivlere kaydedilmesine, depolanmasına, kullanılmasına, güncellenmesine, değiştirilmesine, yeniden düzenlenmesine, sınıflandırılmasına, yurt içinde veya yurt dışına aktarılmasına ve sair kanunlara uygun şekilde işlenmesine, ilgili tüm yasal haklarım hakkında bilgilendirilmiş olarak açıkça izin (rıza/onay) verdiğimi kabul, beyan ve taahhüt ederim.</p>",
      "<p>‘BANDWITT’ tarafından iletişim bilgilerime ticari e-posta ve SMS gönderilmesini kabul ediyorum.</p>",
    ],
  });
  const [modalShow, setModalShow] = useState(false);
  const [modalShow2, setModalShow2] = useState(false);
  const [isChecked, setIsChecked] = useState(0);
  const [isCheckedText, setIsCheckedText] = useState(0);
  const [name, setName] = useState("");
  const [nameActive, setNameActive] = useState(false);
  const [email, setEmail] = useState("");
  const [emailActive, setEmailActive] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [phone, setPhone] = useState("");
  const [isPhone, setIsPhone] = useState(false);
  const [phoneActive, setPhoneActive] = useState(false);
  const [company, setCompany] = useState("");
  const [companyActive, setCompanyActive] = useState(false);
  const [profession, setProfession] = useState("");
  const [professionActive, setProfessionActive] = useState(false);
  const [message, setMessage] = useState("");
  const [messageActive, setMessageActive] = useState(false);
  const [other, setOther] = useState("");
  const [showOther, setShowOther] = useState(false);
  const [isSubmit, setIsSubmit] = useState(0);
  const form = useRef();

  let emailValidate = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
  let phoneValidate =
    /^((\+?[0-9]{1,3})|0)?\s?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

  function sendEmail() {
    emailjs
      .sendForm(
        "service_7svsb9o",
        "template_ik84kn9",
        form.current,
        "5Yw0-u8sxfcnzRpaY"
      )
      .then(() => {
        setIsSubmit(2);
        setName("");
        setEmail("");
        setPhone("");
        setCompany("");
        setProfession("");
        setMessage("");
        setShowOther(false);
        setOther("");
        setIsChecked(0);
        setIsCheckedText(0);
      })
      .then((_) =>
        setTimeout(() => {
          setIsSubmit(0);
        }, 3000)
      );
  }

  const focusOut = (state, setState) => {
    if (state.length === 0) {
      setState(true);
    } else {
      setState(false);
    }
  };

  const changeEvent = (state, setState) => {
    if (state.length === 0) {
      setState(true);
    } else {
      setState(false);
    }
  };

  const changeEmailEvent = () => {
    if (email.length === 0) {
      setEmailActive(true);
      setIsEmail(false);
    } else {
      if (emailValidate.test(email)) {
        setEmailActive(false);
        setIsEmail(true);
      } else {
        setEmailActive(true);
        setIsEmail(false);
      }
    }
  };

  const changePhoneEvent = () => {
    if (phone.length === 0) {
      setPhoneActive(true);
      setIsPhone(false);
    } else {
      if (phone.match(phoneValidate)) {
        setPhoneActive(false);
        setIsPhone(true);
      } else {
        setPhoneActive(true);
        setIsPhone(false);
      }
    }
  };

  const changeSelect = (setStateActive, setState, value) => {
    if (
      value.value !== "0" &&
      value.value !==
        `${
          languageStorage() === "tr"
            ? language[0].sections[6].keys[9].k0010
            : language[1].sections[6].keys[9].k0010
        }`
    ) {
      setStateActive(false);
      if (
        value.options[value.selectedIndex].text ===
        `${
          languageStorage() === "tr"
            ? language[0].sections[6].keys[10].k0011
            : language[1].sections[6].keys[10].k0011
        }`
      ) {
        setShowOther(true);
      } else {
        setShowOther(false);
      }
    } else {
      setStateActive(true);
      setShowOther(false);
    }
    setState(value.options[value.selectedIndex].text);
  };

  const selectFocusOut = (state, setState) => {
    if (
      state ===
        `${
          languageStorage() === "tr"
            ? language[0].sections[6].keys[9].k0010
            : language[1].sections[6].keys[9].k0010
        }` ||
      state === ""
    ) {
      setState(true);
    } else {
      setState(false);
    }
  };

  const submit = () => {
    if (isChecked === 0 || isChecked === 2) {
      setIsChecked(2);
    }
    if (name === "") {
      setNameActive(true);
    }
    if (email === "") {
      setEmailActive(true);
    }
    if (email !== "") {
      if (emailValidate.test(email)) {
        setEmailActive(false);
        setIsEmail(true);
      } else {
        setEmailActive(true);
        setIsEmail(false);
      }
    }
    if (phone === "") {
      setPhoneActive(true);
    }
    if (phone !== "") {
      if (phone.match(phoneValidate)) {
        setPhoneActive(false);
        setIsPhone(true);
      } else {
        setPhoneActive(true);
        setIsPhone(false);
      }
    }
    if (company === "") {
      setCompanyActive(true);
    }
    if (
      profession === "" ||
      profession ===
        `${
          languageStorage() === "tr"
            ? language[0].sections[6].keys[9].k0010
            : language[1].sections[6].keys[9].k0010
        }`
    ) {
      setProfessionActive(true);
    }
    if (message === "") {
      setMessageActive(true);
    }

    if (
      name !== "" &&
      email !== "" &&
      phone !== "" &&
      company !== "" &&
      message !== "" &&
      profession !== "" &&
      profession !==
        `${
          languageStorage() === "tr"
            ? language[0].sections[6].keys[9].k0010
            : language[1].sections[6].keys[9].k0010
        }` &&
      isEmail !== false &&
      isPhone !== false &&
      isChecked !== 0 &&
      isChecked !== 2
    ) {
      setIsSubmit(1);
      sendEmail();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <form className='application-form' ref={form} onSubmit={handleSubmit}>
      <div className='main-input'>
        <input
          className={nameActive ? "error" : ""}
          type='text'
          name='name'
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyUp={(_) => changeEvent(name, setNameActive)}
          onBlur={(_) => focusOut(name, setNameActive)}
        />
        <span className={name !== "" ? "active" : ""}>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[2].k0003
            : language[1].sections[6].keys[2].k0003}
        </span>
        <BsExclamation size='28' color='red' className='hide' />
      </div>
      <div className='main-input'>
        <input
          className={emailActive ? "error" : ""}
          type='email'
          value={email}
          name='email'
          onChange={(e) => setEmail(e.target.value)}
          onKeyUp={(_) => changeEmailEvent()}
          onBlur={(_) => changeEmailEvent()}
        />
        <span className={email !== "" ? "active" : ""}>Email</span>
        <BsExclamation size='28' color='red' className='hide' />
      </div>
      <div className='main-input'>
        <input
          className={phoneActive ? "error" : ""}
          type='number'
          value={phone}
          name='phone'
          onChange={(e) => setPhone(e.target.value)}
          onKeyUp={(_) => changePhoneEvent()}
          onBlur={(_) => changePhoneEvent()}
        />
        <span className={phone !== "" ? "active" : ""}>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[4].k0005
            : language[1].sections[6].keys[4].k0005}
        </span>
        <BsExclamation size='28' color='red' className='hide' />
      </div>
      <div className='main-input'>
        <input
          className={companyActive ? "error" : ""}
          type='text'
          name='company'
          value={company}
          onChange={(e) => setCompany(e.target.value)}
          onKeyUp={(_) => changeEvent(company, setCompanyActive)}
          onBlur={(_) => focusOut(company, setCompanyActive)}
        />
        <span className={company !== "" ? "active" : ""}>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[5].k0006
            : language[1].sections[6].keys[5].k0006}
        </span>
        <BsExclamation size='28' color='red' className='hide' />
      </div>
      <div className='selectDiv'>
        <select
          className={professionActive ? "error" : ""}
          onChange={(e) =>
            changeSelect(setProfessionActive, setProfession, e.target)
          }
          onBlur={(_) => selectFocusOut(profession, setProfessionActive)}
          value={profession}
          name='profession'
        >
          <option value='Other'>
            {languageStorage() === "tr"
              ? language[0].sections[6].keys[6].k0007
              : language[1].sections[6].keys[6].k0007}
          </option>
          {languageStorage() === "tr"
            ? language[0].sections[10].keys.map((item, index) => (
                <option
                  value={
                    language[0].sections[10].keys[index][
                      Object.keys(language[0].sections[10].keys[index])[0]
                    ]
                  }
                  key={index}
                >
                  {
                    language[0].sections[10].keys[index][
                      Object.keys(language[0].sections[10].keys[index])[0]
                    ]
                  }
                </option>
              ))
            : language[1].sections[10].keys.map((item, index) => (
                <option
                  value={
                    language[1].sections[10].keys[index][
                      Object.keys(language[1].sections[10].keys[index])[0]
                    ]
                  }
                  key={index}
                >
                  {
                    language[1].sections[10].keys[index][
                      Object.keys(language[1].sections[10].keys[index])[0]
                    ]
                  }
                </option>
              ))}
          <option value='44'>
            {languageStorage() === "tr"
              ? language[0].sections[6].keys[10].k0011
              : language[1].sections[6].keys[10].k0011}
          </option>
        </select>
        <span>
          {profession === "" ||
          profession ===
            `${
              languageStorage() === "tr"
                ? language[0].sections[6].keys[9].k0010
                : language[1].sections[6].keys[9].k0010
            }`
            ? `${
                languageStorage() === "tr"
                  ? language[0].sections[6].keys[9].k0010
                  : language[1].sections[6].keys[9].k0010
              }`
            : profession}
        </span>
        <BsExclamation size='28' color='red' className='hide' />
      </div>
      <div className={`main-input ${showOther === false ? "hide" : ""}`}>
        <input
          className=''
          type='text'
          value={other}
          onChange={(e) => setOther(e.target.value)}
          name='other'
        />
        <span className={other !== "" ? "active" : ""}>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[10].k0011
            : language[1].sections[6].keys[10].k0011}
        </span>
        <BsExclamation size='28' color='red' className='hide' />
      </div>
      <div className='main-input'>
        <textarea
          className={messageActive ? "error" : ""}
          cols='30'
          name='message'
          rows='6'
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyUp={(_) => changeEvent(message, setMessageActive)}
          onBlur={(_) => focusOut(message, setMessageActive)}
        ></textarea>
        <span className={message !== "" ? "active" : ""}>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[7].k0008
            : language[1].sections[6].keys[7].k0008}
        </span>
        <BsExclamation size='28' color='red' className='hide' />
      </div>
      <div className='main-input-checkbox d-flex align-items-center'>
        <input
          type='checkbox'
          id='kvkk2'
          onChange={(e) => setIsChecked(e.target.checked ? 1 : 2)}
          checked={isChecked === 1 ? true : false}
          name='kvkk'
        />
        <label htmlFor='kvkk2' className={isChecked === 2 ? "label-error" : ""}>
          <span onClick={() => setModalShow(true)}>
            {languageStorage() === "tr"
              ? language[0].sections[6].keys[12].k0013
              : language[1].sections[6].keys[12].k0013}
          </span>{" "}
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[13].k0014
            : language[1].sections[6].keys[13].k0014}
        </label>
        <TextModal
          title={kvkkPolicy.title}
          text={kvkkPolicy.text}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      </div>
      <div className='main-input-checkbox d-flex align-items-start'>
        <input
          type='checkbox'
          id='acik-riza-metni2'
          name='consent-text'
          onChange={(e) => setIsCheckedText(e.target.checked ? 1 : 2)}
          checked={isCheckedText === 1 ? true : false}
        />
        <label htmlFor='acik-riza-metni2'>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[14].k0015
            : language[1].sections[6].keys[14].k0015}
          &nbsp;
          <span onClick={() => setModalShow2(true)}>
            {languageStorage() === "tr"
              ? language[0].sections[6].keys[15].k0016
              : language[1].sections[6].keys[15].k0016}
          </span>{" "}
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[16].k0017
            : language[1].sections[6].keys[16].k0017}
        </label>
        <TextModal
          title={consentText.title}
          text={consentText.text}
          show={modalShow2}
          onHide={() => setModalShow2(false)}
        />
      </div>
      <button onClick={() => submit()}>
        <div className={isSubmit === 1 ? "spinner" : "hide"}></div>
        <span className={isSubmit === 1 ? "hide" : ""}>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[17].k0018
            : language[1].sections[6].keys[17].k0018}
        </span>
      </button>
      <div
        className={`sent d-flex align-items-center justify-content-center  ${
          isSubmit === 2 ? "" : "hide"
        }`}
      >
        <BsCheck2 size='24' />
        <span>
          {languageStorage() === "tr"
            ? language[0].sections[6].keys[18].k0019
            : language[1].sections[6].keys[18].k0019}
        </span>
      </div>
    </form>
  );
}
